import React from 'react';

import {SidebarItem} from 'app/general/structures/SidebarItem';
import {currVersionTooltipTextSelector} from 'app/procedures/selectors';
import {getContentType} from 'app/utils/content-type';
import {getPathFromURL} from 'app/utils/urls';

import type {LeftSidebarMenuButton} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {DetailPageItemType} from 'app/components/general/DetailPage/types';

export function LeftMainMenuButton<ItemType extends DetailPageItemType>({
  object,
  forceTooltipShow,
  hideTooltip,
}: Omit<LeftSidebarMenuButton<ItemType>, 'active'>) {
  const contentType = getContentType(object.content_type);
  return (
    <SidebarItem
      title={currVersionTooltipTextSelector(object)}
      icon={contentType.icon}
      link={getPathFromURL(object.html_url)}
      forceTooltipShow={forceTooltipShow}
      onClick={hideTooltip}
    />
  );
}
